module.exports = __webpack_public_path__ + "img/mda.999f55c1.svg";